<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <div class="d-flex align-items-center justify-content-end mb-3">
          <a
            href="javascript:void(0)"
            @click="$router.go(-1)"
          >
            <CIcon
              name="cil-arrow-left"
              class="mr-2"
            />Voltar
          </a>
        </div>

        <!-- Title -->
        <CCard>
          <CCardHeader>
            <div class="d-flex justify-content-between align-items-center">
              <h4 class="mb-0">
                {{ $route.params.id ? 'Editar Seção' : 'Cadastrar Seção' }}
              </h4>

              <div class="d-flex align-items-center">
                <div class="ml-2 d-flex align-items-center">
                  <!-- Status -->
                  <label class="mb-0">
                    <b>Status</b>
                  </label>
                  <CSwitch
                    type="checkbox"
                    color="success"
                    variant="3d"
                    class="mx-2"
                    v-bind="labelIcon"
                    :checked.sync="form.status"
                  />
                </div>
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Content -->
        <CCard>
          <CCardBody>
            <CTabs
              :active-tab="activeTabIndex"
              :vertical="vertical"
              :variant="variant"
              add-nav-wrapper-classes="website-tabs"
              add-tabs-wrapper-classes="website-tabs"
              class="ml-1"
              @update:activeTab="handleActiveTab"
            >
              <!-- BR -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/pt-br.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Português
                    <TabsStatus :exibition="form.status" />
                  </div>
                </template>

                <!-- Fields -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>
                </div>

                <CRow>
                  <!-- Title -->
                  <CCol col="12">
                    <CInput
                      id="first"
                      v-model="form.title"
                      label="Título*"
                      :disabled="processing"
                    />
                  </CCol>

                  <!-- Description -->
                  <CCol col="12">
                    <div class="form-group">
                      <label for="mission">Descrição*</label>

                      <TextEditor
                        id="mission"
                        v-model="form.description"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Videos -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Vídeos
                    <small class="pl-2 pt-1 text-muted">(Inclua abaixo os videos relacionados a seção)</small>
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <ListItem
                      :items="form.links"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- Files -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Arquivos
                  </h5>
                </div>

                <CRow>
                  <CCol lg="12">
                    <div class="form-group">
                      <FileUploader
                        id="code-conduct"
                        :uploader-info="uploaderInfoFiles"
                        :enable-multiple="true"
                        :max-files="150"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="true"
                        :accept-types="acceptTypesFiles"
                        :extensions="extensionsFiles"
                        :medias="form.medias"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    SEO
                  </h5>
                </div>

                <CRow>
                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug"
                      :based-on="form.title"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug"
                      model="chapters"
                      @change="(value) => form.slug = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo"
                  :page-title="form.title"
                  :page-description="form.description"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- EN -->
              <CTab>
                <!-- Tab title -->
                <template
                  slot="title"
                >
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/en.svg`)"
                      alt="Bandeira Inglesa"
                      class="flag mr-2"
                    />
                    Inglês
                    <TabsStatus :exibition="form.status_en && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_en"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_en"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="description">Descrição*</label>

                      <TextEditor
                        id="english-description"
                        v-model="form.description_en"
                        type="simpletext"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Videos -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Vídeos
                        <small class="pl-2 pt-1 text-muted">(Inclua abaixo os videos relacionados a seção)</small>
                      </h5>
                    </div>
                  </CCol>

                  <CCol lg="12">
                    <ListItem
                      :items="form.links_en"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- Files -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Arquivos
                      </h5>
                    </div>

                    <div class="form-group">
                      <FileUploader
                        id="code-conduct"
                        :uploader-info="uploaderInfoFiles"
                        :enable-multiple="true"
                        :max-files="150"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="true"
                        :accept-types="acceptTypesFiles"
                        :extensions="extensionsFiles"
                        :medias="form.medias_en"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_en"
                      :based-on="form.title_en"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_en"
                      model="chapters"
                      @change="(value) => form.slug_en = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_en"
                  :page-title="form.title_en"
                  :page-description="form.description_en"
                  :is-edit="!!$route.params.id"
                />
              </CTab>

              <!-- ES -->
              <CTab>
                <!-- Tab title -->
                <template slot="title">
                  <div class="d-flex align-items-center">
                    <img
                      :src="require(`@/assets/img/flags/es.svg`)"
                      alt="Bandeira Espanhola"
                      class="flag mr-2"
                    />
                    Espanhol
                    <TabsStatus :exibition="form.status_es && form.status" />
                  </div>
                </template>

                <!-- Title -->
                <div class="subtitle">
                  <h5>
                    <CIcon
                      name="cil-justify-center"
                    />
                    Informações
                  </h5>

                  <div class="d-flex align-items-center">
                    <div class="ml-2 d-flex align-items-center">
                      <label class="mb-0">
                        <b>Exibir</b>
                      </label>

                      <CSwitch
                        type="checkbox"
                        color="success"
                        variant="3d"
                        class="mx-2"
                        v-bind="labelIcon"
                        :checked.sync="form.status_es"
                      />
                    </div>
                  </div>
                </div>

                <!-- Fields -->
                <CRow>
                  <CCol col="12">
                    <CInput
                      v-model="form.title_es"
                      :label="`Título*`"
                      :disabled="processing"
                    />
                  </CCol>

                  <CCol col="12">
                    <div class="form-group">
                      <label for="spanish-description">Descrição*</label>
                      <TextEditor
                        id="spanish-description"
                        v-model="form.description_es"
                        :disabled="processing"
                        type="simpletext"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- Videos -->
                <CRow>
                  <CCol col="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Vídeos
                        <small class="pl-2 pt-1 text-muted">(Inclua abaixo os videos relacionados a seção)</small>
                      </h5>
                    </div>
                  </CCol>

                  <CCol col="12">
                    <ListItem
                      :items="form.links_es"
                      :fields="fieldsLinks"
                      :disabled="processing"
                    />
                  </CCol>
                </CRow>

                <!-- Files -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        Arquivos
                      </h5>
                    </div>

                    <div class="form-group">
                      <FileUploader
                        id="code-conduct"
                        :uploader-info="uploaderInfoFiles"
                        :enable-multiple="true"
                        :max-files="150"
                        :enable-crop-on-uploader="false"
                        :enable-edit-on-api-table="true"
                        :accept-types="acceptTypesFiles"
                        :extensions="extensionsFiles"
                        :medias="form.medias_es"
                        :disabled="processing"
                      />
                    </div>
                  </CCol>
                </CRow>

                <!-- SEO -->
                <CRow>
                  <CCol lg="12">
                    <div class="subtitle">
                      <h5>
                        <CIcon
                          name="cil-justify-center"
                        />
                        SEO
                      </h5>
                    </div>
                  </CCol>

                  <CCol
                    lg="12"
                  >
                    <FriendlyUrl
                      :value="form.slug_es"
                      :based-on="form.title_es"
                      :disabled="processing"
                      :entity="$route.params.id"
                      field="slug_es"
                      model="chapters"
                      @change="(value) => form.slug_es = value"
                    />
                  </CCol>
                </CRow>

                <Seo
                  :form="form.seo_es"
                  :page-title="form.title_es"
                  :page-description="form.description_es"
                  :is-edit="!!$route.params.id"
                />
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            v-if="$route.params.id"
            href="javascript:void(0)"
            class="mr-3"
            @click="resetForm"
          >Limpar Alterações</a>
          <CInputCheckbox
            v-else
            label="Criar outro"
            class="mr-3"
            :disabled="processing"
            @update:checked="setRedirect"
          />
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import Modal from '@/components/ui/Modal'
import Seo from '@/components/ui/Seo'
import TabsStatus from '@/components/ui/TabsStatus'
import TextEditor from '@/components/ui/TextEditor'
import ListItem from '@/components/ui/ListItem'
import FileUploader from '@/components/ui/Fileuploader'
import CardLog from '@/components/ui/CardLog'
import FriendlyUrl from '@/components/ui/FriendlyUrl'

import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/chapter.service'

export default {
  metaInfo: {
    title: 'Seções',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_sections')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    Modal,
    Seo,
    TabsStatus,
    TextEditor,
    ListItem,
    FileUploader,
    CardLog,
    FriendlyUrl
  },

  data() {
    return {
      vertical: false,
      variant: 'tabs',
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        status: true,
        status_en: false,
        status_es: false,
        title: '',
        title_en: '',
        title_es: '',
        slug: '',
        slug_en: '',
        slug_es: '',
        description: '',
        description_en: '',
        description_es: '',
        seo: {
          seo_title: '',
          seo_description: ''
        },
        seo_en: {
          seo_title: '',
          seo_description: ''
        },
        seo_es: {
          seo_title: '',
          seo_description: ''
        },
        links: [],
        links_en: [],
        links_es: [],
        medias: [],
        medias_en: [],
        medias_es: []
      },
      form: {},
      fieldsLinks: [
        {
          key: 'title',
          label: 'Título',
          type: 'text',
          required: true,
          disabled: false,
          placeholder: 'Digite o título',
          _classes: 'col-lg-5',
          _style: ''
        },
        {
          key: 'url',
          label: 'URL',
          type: 'link',
          required: true,
          disabled: false,
          placeholder: 'Digite o link',
          _classes: 'col-lg-5',
          _style: ''
        }
      ],
      acceptTypesFiles: 'application/pdf,image/png,image/jpeg',
      extensionsFiles: 'jpg,jpeg,png, pdf',
      uploaderInfoFiles: {
        label: 'Arquivos'
      },
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      activeTabIndex: 0,
      redirect: true
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            id: this.$route.params.id,
            title: data.title,
            title_en: data.title_en,
            title_es: data.title_es,
            slug: data.slug,
            slug_en: data.slug_en,
            slug_es: data.slug_es,
            description: data.description,
            description_en: data.description_en,
            description_es: data.description_es,
            status: !!data.status,
            status_en: !!data.status_en,
            status_es: !!data.status_es,
            seo: {
              seo_title: data.seo.title,
              seo_description: data.seo.description
            },
            seo_en: {
              seo_title: data.seo_en.title,
              seo_description: data.seo_en.description
            },
            seo_es: {
              seo_title: data.seo_es.title,
              seo_description: data.seo_es.description
            },
            links: data.links,
            links_en: data.links_en,
            links_es: data.links_es,
            medias: data.medias,
            medias_en: data.medias_en,
            medias_es: data.medias_es
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
    },

    resetForm() {
      this.setItem()
    },

    setRedirect(event) {
      this.redirect = !event
    },

    handleActiveTab(index) {
      this.activeTabIndex = index
    },

    async send() {
      this.processing = true

      let response
      let message

      const data = {
        id: this.$route.params.id,
        title: this.form.title,
        title_en: this.form.title_en,
        title_es: this.form.title_es,
        slug: this.form.slug,
        slug_en: this.form.slug_en,
        slug_es: this.form.slug_es,
        description: this.form.description,
        description_en: this.form.description_en,
        description_es: this.form.description_es,
        status: this.form.status,
        status_en: this.form.status_en,
        status_es: this.form.status_es,
        seo_title: this.form.seo.seo_title,
        seo_description: this.form.seo.seo_description,
        seo_title_en: this.form.seo_en.seo_title,
        seo_description_en: this.form.seo_en.seo_description,
        seo_title_es: this.form.seo_es.seo_title,
        seo_description_es: this.form.seo_es.seo_description,
        medias: this.form.medias.map((media) => media.id),
        medias_en: this.form.medias_en.map((media) => media.id),
        medias_es: this.form.medias_es.map((media) => media.id)
      }

      data.links = this.form.links.map(link => {
        return {
          title: link.title, url: link.url
        }
      })
      data.links_en = this.form.links_en.map(link => {
        return {
          title: link.title, url: link.url
        }
      })
      data.links_es = this.form.links_es.map(link => {
        return {
          title: link.title, url: link.url
        }
      })

      if (this.$route.params.id) {
        response = await Service.update(this.$route.params.id, data)
        message = 'Seção foi atualizada com sucesso!'
      } else {
        response = await Service.store(data)
        message = 'Seção foi cadastrada com sucesso!'
      }

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: this.redirect
        }

        if (this.redirect) {
          this.resetForm()
          setTimeout(() => {
            this.$router.push(
              this.$route.matched[this.$route.matched.length - 2].path
            )
          }, 3000)
        } else {
          this.resetForm()
          setTimeout(() => {
            this.processing = false
            document.getElementById('first').focus()
            this.modal.show = false
          }, 1000)
        }
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: response.data.messages[0].message || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
